import {Injectable, Injector} from '@angular/core';
import { UserService } from './user.service';
import { ERPIntegrationService } from './erp-integration.service';
import { EventService } from './event.service';
import { EventName } from 'app/shared/enums';
import { AttentionModel } from 'app/models/shared/attention.model';

@Injectable({ providedIn: 'root' })
export class AppBoostrapService {
  protected userService: UserService;
  protected erpService: ERPIntegrationService;
  protected eventService: EventService;

  constructor(private injector: Injector) {
    this.userService = this.injector.get(UserService);
    this.erpService = this.injector.get(ERPIntegrationService);
    this.eventService = this.injector.get(EventService);
  }

  bootstrap() {
    if (this.userService.isLoggedIn()) {
      // Skip ERP interruption check if user is already on ERP settings page
      if (location.pathname.startsWith('/erp-integration')) {
        return;
      }

      // Check dismiss state BEFORE making the API call
      const dismissedAt = localStorage.getItem('erp_interrupt_dismissed');
      const isDismissed = dismissedAt && (Date.now() - parseInt(dismissedAt, 10)) < 24 * 60 * 60 * 1000;
      if (isDismissed) {
        return;
      }

      this.erpService.checkERPsInterrupted().subscribe((res) => {
        if (res.data && res.data.length > 0) {
          let erpList = '';

          for (const erp of res.data) {
            const organizationList = erp.organizations.map(organization => `<li>${organization.name}</li>`).join('');
            erpList += `<ul>${erp.erp_type?.to1stCharCapital()} ${organizationList}</ul>`;
          }

          this.eventService.broadcast(EventName.ErpInterrupted, new AttentionModel({
            visible: true,
            messageHtml: `<p>The ERP(s) below has been interrupted. Please reconnect to keep your work continuous.</p> <div class="list-content">${erpList}</div>`,
            buttonText: 'Reconnect',
            blocking: false,
            isAlert: false,
            action: 'DEFAULT',
            section: 'DEFAULT',
          }));
        }
      });
    }
  }
}
